import { call, put, takeEvery, getContext } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { removeProductFromBasket } from './RemoveProductFromBasketSaga';
import { BasketCartItemError } from '@as-react/common-types';
export function* changeSizeUpdate(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const updatedProduct = Object.assign(Object.assign({}, action.payload.product), { sku: action.payload.newSku });
        yield call(removeProductFromBasket, action);
        yield call(BasketAPI.addProductToBasket, updatedProduct, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createAddSuccessAction({ product: updatedProduct }));
        yield put(basketActions.createGetBasicAction());
        yield put(basketActions.createGetAction());
    }
    catch (_a) {
        yield put(basketActions.createGetBasicAction());
        yield put(basketActions.createGetAction());
        yield put(basketActions.createUpdateItemsErrorStateAction(BasketCartItemError.ADD_FAILED, action.payload.product));
    }
}
export function* changeSizeSaga() {
    yield takeEvery(BasketActionTypes.CHANGE_SIZE, changeSizeUpdate);
}
